import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "kanan_cart";

export const itemPrice = (i) => {
  if (i.variantLabel) {
    const v = (i.product.variants || []).find((v) => v.label === i.variantLabel);
    if (v) return v.price;
  }
  return i.product.price;
};

export const itemPack = (i) => i.variantLabel || i.product.pack;

export const itemKey = (i) => `${i.product.id}__${i.variantLabel || "base"}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1, variantLabel = null) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product.id === product.id && (i.variantLabel || null) === variantLabel);
      if (existing) return prev.map((i) => itemKey(i) === itemKey(existing) ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { product, variantLabel, qty }];
    });
    setOpen(true);
  }, []);

  const setQty = useCallback((key, qty) => {
    setItems((prev) => qty <= 0 ? prev.filter((i) => itemKey(i) !== key) : prev.map((i) => itemKey(i) === key ? { ...i, qty } : i));
  }, []);

  const remove = useCallback((key) => setItems((prev) => prev.filter((i) => itemKey(i) !== key)), []);
  const clear = useCallback(() => setItems([]), []);

  const total = useMemo(() => items.reduce((s, i) => s + itemPrice(i) * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);
  const hasRx = useMemo(() => items.some((i) => i.product.rx), [items]);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, total, count, hasRx, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
